import { createUseEntityList, createUseEntity } from 'api/base-hooks';
import { offerApi } from './offer';
import { OfferListResponse, OfferResponse } from './offer-types';

const SECTION = 'offer';

export const useOfferList = createUseEntityList<OfferListResponse>(SECTION, offerApi.getList);
export const useOffer = createUseEntity<OfferResponse>(SECTION, offerApi.getItem);
